module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_6-622f3cc1082734ece2a1cc0db03d98d8.jpg";